import type { ReactNode } from 'react';

export type LegalDisclosureProps = {
  children: ReactNode;
  title?: string;
};

export function LegalDisclosure({ children, title = 'Disclosure' }: LegalDisclosureProps) {
  return (
    <section aria-label={title}>
      <h2 className="typography-smaller-headline mb-1">{title}</h2>
      <div className="typography-text-small text-muted-foreground">{children}</div>
    </section>
  );
}
